import { HTTP_MESSAGE_HEADER } from 'constants/HttpMessageHeaderState';

type HttpMessageHeaders = Headers | Record<string, unknown> | null | undefined;
type HttpMessageHeaderName =
  (typeof HTTP_MESSAGE_HEADER)[keyof typeof HTTP_MESSAGE_HEADER];

export function getHttpMessageHeader(
  headers: HttpMessageHeaders,
  headerName: HttpMessageHeaderName,
): string | undefined {
  if (!headers) {
    return undefined;
  }

  if (headers instanceof Headers) {
    return headers.get(headerName) ?? undefined;
  }

  const normalizedHeaderName = headerName.toLowerCase();
  const messageHeader = Object.entries(headers).find(
    ([name]) => name.toLowerCase() === normalizedHeaderName,
  );

  return typeof messageHeader?.[1] === 'string' ? messageHeader[1] : undefined;
}
